import { useContainer } from "./useContainer";

export const useAppApiClient = () => useContainer().appApiClient;

export type AppApiClient = ReturnType<typeof useAppApiClient>;
